function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivityIssueResolved = function SvgActivityIssueResolved(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.938,
    height: 15,
    viewBox: "0 0 15.938 15"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m737.794 519.635-6.268-11.772a1.69 1.69 0 0 0-2.958-.009l-6.361 11.772a1.626 1.626 0 0 0 1.477 2.381h12.629a1.626 1.626 0 0 0 1.481-2.372Zm-8.922.422-2.708-2.638 1.157-1.126 1.491 1.452 3.517-3.709 1.213 1.069Z",
    style: {
      fill: "#403f40",
      fillRule: "evenodd"
    },
    transform: "translate(-722.031 -507)"
  }));
};
export default SvgActivityIssueResolved;